import { render, staticRenderFns } from "./CasesEdit.vue?vue&type=template&id=01619740&"
import script from "./CasesEdit.vue?vue&type=script&lang=js&"
export * from "./CasesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports